const HTML_ESCAPES: Record<string, string> = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };

export const escapeHtml = (value: unknown): string => String(value).replace(/[&<>"']/g, (c) => HTML_ESCAPES[c] ?? c);

/** Text content of an HTML fragment. Parses inertly: scripts and event handlers in the input never run. */
export function htmlToText(html: string | null | undefined): string {
  if (!html) return '';
  const doc = new DOMParser().parseFromString(html, 'text/html');
  return doc.body.textContent.replace(/\s+/g, ' ').trim();
}

/** Removes tags with a regex. For trusted, in-repo HTML only (e.g. FAQ answers for JSON-LD). */
export const stripTags = (html: string): string =>
  html
    .replace(/<[^>]+>/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

const SAFE_URL_SCHEMES = new Set(['http:', 'https:', 'mailto:']);

/**
 * Returns the URL if it is relative or uses http(s)/mailto, otherwise an empty string.
 * Use for URLs from external data (feeds, JSON files) before putting them into markup.
 */
export function safeUrl(url: unknown): string {
  if (typeof url !== 'string') return '';
  const trimmed = url.trim();
  if (!trimmed) return '';
  if (trimmed.startsWith('/') && !trimmed.startsWith('//')) return trimmed;
  try {
    return SAFE_URL_SCHEMES.has(new URL(trimmed).protocol) ? trimmed : '';
  } catch {
    return '';
  }
}

export const isHttpUrl = (url: string): boolean => /^https?:/i.test(url);
